/* eslint-disable react-hooks/exhaustive-deps */

import { TYPE_INSTANCE1 } from "App/constants";
import { fetchData } from "App/utils/helpers";
import { useState, useEffect, useCallback } from "react";

const useSelectOption = (
  withSearch = false,
  url = "/formula/listformula",
  type = TYPE_INSTANCE1,
  val = "id",
  label = "name",
  response = "body",
  options = {},
  subdata = undefined
) => {
  const DEFAULT_OPTION = withSearch
    ? []
    : [
        {
          label: "Pilih",
          value: "",
        },
      ];

  const [state, setState] = useState(DEFAULT_OPTION);
  const fetch = useCallback(async () => {
    const res = await fetchData(type, url, response, options, subdata);
    if (res) {
      const data = withSearch
        ? []
        : [
            {
              value: "",
              label: "Pilih",
            },
          ];
      res.map((item) => {
        return data.push({
          value: item[val],
          label: item[label],
        });
      });

      setState(data);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [withSearch, url, type, val, label, response]); // eslint-disable-line react-hooks/exhaustive-deps

  return state;
};

export default useSelectOption;
